import { configureStore } from '@reduxjs/toolkit'
import { useStore } from 'react-redux'
import restClient from 'Shared/hooks/restClient'

import answers from 'FlowBuilder/store/answers' // NOTE: Using FlowBuilder's answers store as we use its components in the DashboardBuilder
import builder from 'DashboardBuilder/store/builder'
import dashboard from 'DashboardBuilder/store/dashboard'
import dashboardFields from 'DashboardBuilder/store/dashboardFields'
import local from 'DashboardBuilder/store/local'
import questions from 'FlowBuilder/store/questions' // NOTE: Using FlowBuilder's questions store as we use its components in the DashboardBuilder
import search from 'DashboardBuilder/store/search'
import dashboardTargets from 'DashboardUser/store/dashboardTargets'

// the reducers and actions for each slice are stored together in slices/sliceName.js
const slices = {
  answers,
  builder,
  dashboard,
  dashboardFields,
  dashboardTargets,
  local,
  questions,
  search
}

const store = configureStore({
  reducer: _.mapValues(slices, (slice) => slice.reducer),
  devTools: {
    name: 'Dashboard builder',
  },
})

const useAct = () => {
  const dis = useDis()
  const store = useStore()

  return useMemo(
    () => _.mapValues(slices, (fn) => {
      return fn.actions(dis, store, restClient)
    }),
    []
  )
}

export { store, useAct }
